module.exports = __webpack_public_path__ + "3975909c7d6d693f49cab9893d5fb6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/eraser-icon.png
// module id = 25
// module chunks = 0